/* ==========================================================================
   SAÜDA — Comportamientos propios
   Sin dependencias. Todo degrada bien si el script no llega a cargar.
   ========================================================================== */
(function () {
  'use strict';

  var sinMovimiento = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ------------------------------------------------------------------------
     1. Aparición al hacer scroll
     Solo para elementos marcados con .sauda-revelar, que nunca están sobre el
     pliegue. Si no hay IntersectionObserver, se muestran todos de golpe.
     ---------------------------------------------------------------------- */
  function revelar() {
    var piezas = document.querySelectorAll('.sauda-revelar:not(.esta-visible)');
    if (!piezas.length) return;

    if (sinMovimiento || !('IntersectionObserver' in window)) {
      piezas.forEach(function (p) { p.classList.add('esta-visible'); });
      return;
    }

    var observador = new IntersectionObserver(
      function (entradas) {
        entradas.forEach(function (entrada) {
          if (!entrada.isIntersecting) return;
          entrada.target.classList.add('esta-visible');
          observador.unobserve(entrada.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.06 }
    );

    piezas.forEach(function (p, i) {
      p.style.transitionDelay = Math.min(i % 6, 5) * 70 + 'ms';
      observador.observe(p);
    });
  }

  /* ------------------------------------------------------------------------
     2. Acordeón: solo uno abierto a la vez dentro del mismo grupo
     ---------------------------------------------------------------------- */
  function acordeones() {
    document.querySelectorAll('.sauda-acordeon').forEach(function (grupo) {
      var detalles = grupo.querySelectorAll('details');
      detalles.forEach(function (d) {
        d.addEventListener('toggle', function () {
          if (!d.open) return;
          detalles.forEach(function (otro) {
            if (otro !== d) otro.open = false;
          });
        });
      });
    });
  }

  /* ------------------------------------------------------------------------
     3. Menú desplegable: se abre al pasar el cursor y el padre es clicable
     Dawn monta el desplegable con <details><summary>, así que solo se abre
     al hacer clic y la entrada padre no lleva a ninguna parte. Aquí:
       · en escritorio se abre al pasar el cursor y se cierra al salir
       · un clic en el padre navega a su colección en vez de no hacer nada
     En móvil no se toca nada: sin ratón, el clic tiene que seguir abriendo.
     ---------------------------------------------------------------------- */
  function menuDesplegable() {
    var conRaton = window.matchMedia('(hover: hover) and (pointer: fine)');
    var desplegables = document.querySelectorAll('[data-sauda-desplegable]');
    if (!desplegables.length) return;

    desplegables.forEach(function (det) {
      var resumen = det.querySelector('summary');
      if (!resumen) return;
      var cierre;

      det.addEventListener('mouseenter', function () {
        if (!conRaton.matches) return;
        clearTimeout(cierre);
        det.open = true;
      });

      det.addEventListener('mouseleave', function () {
        if (!conRaton.matches) return;
        // Un respiro antes de cerrar: si no, el menú se escapa al bajar el ratón
        cierre = setTimeout(function () { det.open = false; }, 180);
      });

      resumen.addEventListener('click', function (e) {
        if (!conRaton.matches) return;          // en móvil, comportamiento normal
        var url = resumen.dataset.saudaEnlace;
        if (!url || url === '#') return;
        e.preventDefault();
        window.location.href = url;
      });

      // Con teclado se sigue abriendo con Enter, no navega
      resumen.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') e.stopPropagation();
      });
    });

    // Al pulsar fuera se cierran todos
    document.addEventListener('click', function (e) {
      desplegables.forEach(function (det) {
        if (!det.contains(e.target)) det.open = false;
      });
    });
  }

  /* ------------------------------------------------------------------------
     4. Extras de la ficha de producto
     La barra de confianza y el acordeón se imprimen en el layout, fuera de la
     sección de producto, y desde aquí se llevan a su sitio dentro de la
     columna de información.

     ¿Por qué así y no como bloques de la sección? Porque tocar
     templates/product.json o el {% schema %} de main-product.liquid tumbaba
     todas las fichas con un 404. Desde el layout no hay nada que validar.
     Si este script fallara, los extras simplemente no aparecen: la ficha
     sigue funcionando igual.
     ---------------------------------------------------------------------- */
  function fichaExtra() {
    var origen = document.getElementById('sauda-ficha-extra');
    if (!origen) return;

    var columna = document.querySelector('.product__info-container');
    if (!columna) return;

    var confianza = origen.querySelector('[data-sauda-mover="confianza"]');
    var acordeon = origen.querySelector('[data-sauda-mover="acordeon"]');

    // La barra de confianza va justo debajo del botón de compra
    if (confianza) {
      var formulario = columna.querySelector('.product-form');
      var anclaje = formulario ? formulario.closest('.product__info-container > *') || formulario : null;
      if (anclaje && anclaje.parentNode) {
        anclaje.parentNode.insertBefore(confianza, anclaje.nextSibling);
      } else {
        columna.appendChild(confianza);
      }
    }

    // El acordeón, al final de todo
    if (acordeon) columna.appendChild(acordeon);

    origen.remove();
    acordeones();
  }

  /* ------------------------------------------------------------------------
     Arranque
     ---------------------------------------------------------------------- */
  function arrancar() {
    revelar();
    acordeones();
    menuDesplegable();
    fichaExtra();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }

  // El editor de temas reinyecta secciones sin recargar la página
  document.addEventListener('shopify:section:load', function () {
    revelar();
    acordeones();
    menuDesplegable();
  });
})();
